// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Restore pre-PrimeNG-18 navbar look: transparent menubar over the black header,
   white menu text, no card background/border/rounded corners. */
:host ::ng-deep .p-menubar {
    background: transparent;
    border: 0;
    border-radius: 0;
    padding: 0;
    color: #ffffff;
}

:host ::ng-deep .p-menubar .p-menubar-root-list {
    background: transparent;
    gap: 0;
    flex-wrap: nowrap;
    white-space: nowrap;
}

:host ::ng-deep .p-menubar .p-menubar-root-list > .p-menubar-item {
    flex: 0 0 auto;
}

:host ::ng-deep .p-menubar .p-menubar-item-link {
    white-space: nowrap;
}

:host ::ng-deep .p-menubar .p-menubar-item-link,
:host ::ng-deep .p-menubar .p-menubar-item-link .p-menubar-item-label,
:host ::ng-deep .p-menubar .p-menubar-item-link .p-menubar-item-icon,
:host ::ng-deep .p-menubar .p-menubar-item-link .p-menubar-submenu-icon {
    color: #ffffff;
    background: transparent;
}

:host ::ng-deep .p-menubar .p-menubar-item > .p-menubar-item-content:hover,
:host ::ng-deep .p-menubar .p-menubar-item.p-focus > .p-menubar-item-content,
:host ::ng-deep .p-menubar .p-menubar-item.p-menubar-item-active > .p-menubar-item-content {
    background: rgba(255, 255, 255, 0.12);
    color: #ffffff;
}

/* Submenu (dropdown) panel keeps its standard look but with readable contrast */
:host ::ng-deep .p-menubar .p-menubar-submenu {
    background: #ffffff;
    color: #000000;
    border: 1px solid #e5e7eb;
    border-radius: 4px;
    padding: 4px 0;
}

:host ::ng-deep .p-menubar .p-menubar-submenu .p-menubar-item-link,
:host ::ng-deep .p-menubar .p-menubar-submenu .p-menubar-item-link .p-menubar-item-label,
:host ::ng-deep .p-menubar .p-menubar-submenu .p-menubar-item-link .p-menubar-item-icon {
    color: #000000;
}

:host ::ng-deep .p-menubar .p-menubar-submenu .p-menubar-item > .p-menubar-item-content:hover {
    background: #f3f4f6;
    color: #000000;
}
`, "",{"version":3,"sources":["webpack://./src/app/out-of-application/top-navbar/top-navbar.component.css"],"names":[],"mappings":"AAAA;gEACgE;AAChE;IACI,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,MAAM;IACN,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;;;IAII,cAAc;IACd,uBAAuB;AAC3B;;AAEA;;;IAGI,qCAAqC;IACrC,cAAc;AAClB;;AAEA,gFAAgF;AAChF;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB","sourcesContent":["/* Restore pre-PrimeNG-18 navbar look: transparent menubar over the black header,\r\n   white menu text, no card background/border/rounded corners. */\r\n:host ::ng-deep .p-menubar {\r\n    background: transparent;\r\n    border: 0;\r\n    border-radius: 0;\r\n    padding: 0;\r\n    color: #ffffff;\r\n}\r\n\r\n:host ::ng-deep .p-menubar .p-menubar-root-list {\r\n    background: transparent;\r\n    gap: 0;\r\n    flex-wrap: nowrap;\r\n    white-space: nowrap;\r\n}\r\n\r\n:host ::ng-deep .p-menubar .p-menubar-root-list > .p-menubar-item {\r\n    flex: 0 0 auto;\r\n}\r\n\r\n:host ::ng-deep .p-menubar .p-menubar-item-link {\r\n    white-space: nowrap;\r\n}\r\n\r\n:host ::ng-deep .p-menubar .p-menubar-item-link,\r\n:host ::ng-deep .p-menubar .p-menubar-item-link .p-menubar-item-label,\r\n:host ::ng-deep .p-menubar .p-menubar-item-link .p-menubar-item-icon,\r\n:host ::ng-deep .p-menubar .p-menubar-item-link .p-menubar-submenu-icon {\r\n    color: #ffffff;\r\n    background: transparent;\r\n}\r\n\r\n:host ::ng-deep .p-menubar .p-menubar-item > .p-menubar-item-content:hover,\r\n:host ::ng-deep .p-menubar .p-menubar-item.p-focus > .p-menubar-item-content,\r\n:host ::ng-deep .p-menubar .p-menubar-item.p-menubar-item-active > .p-menubar-item-content {\r\n    background: rgba(255, 255, 255, 0.12);\r\n    color: #ffffff;\r\n}\r\n\r\n/* Submenu (dropdown) panel keeps its standard look but with readable contrast */\r\n:host ::ng-deep .p-menubar .p-menubar-submenu {\r\n    background: #ffffff;\r\n    color: #000000;\r\n    border: 1px solid #e5e7eb;\r\n    border-radius: 4px;\r\n    padding: 4px 0;\r\n}\r\n\r\n:host ::ng-deep .p-menubar .p-menubar-submenu .p-menubar-item-link,\r\n:host ::ng-deep .p-menubar .p-menubar-submenu .p-menubar-item-link .p-menubar-item-label,\r\n:host ::ng-deep .p-menubar .p-menubar-submenu .p-menubar-item-link .p-menubar-item-icon {\r\n    color: #000000;\r\n}\r\n\r\n:host ::ng-deep .p-menubar .p-menubar-submenu .p-menubar-item > .p-menubar-item-content:hover {\r\n    background: #f3f4f6;\r\n    color: #000000;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
